import {
    Container,
    Content,
    Body,
    Title,
    Children,
    Actions
} from './styled';

export function Alert(props) {

    const {
        children,
        title,
        isOpen,
        onClickOption1,
        onClickOption2
    } = props;

    return (
        <Container isOpen={isOpen}>
            <Content>
                <Body>
                    <Title>{title}</Title>
                    <Children>{children}</Children>
                </Body>
                <Actions>
                    <div onClick={() => { onClickOption1() }}>
                        {`Sim`}
                    </div>
                    <div onClick={() => { onClickOption2() }}>
                        {`Não`}
                    </div>
                </Actions>
            </Content>
        </Container>
    );
}